// extracted by mini-css-extract-plugin
export var container = "index-module--container--1C9JY";
export var newsEntry = "index-module--newsEntry--Rx1Fi";
export var featuredImage = "index-module--featuredImage--17HEO";
export var newsEntryRecent = "index-module--newsEntryRecent--Yu2Kv index-module--newsEntry--Rx1Fi";
export var contentRecent = "index-module--contentRecent--3KEYX";
export var tags = "index-module--tags--Uox2f";
export var links = "index-module--links--YdQvq";